import { render } from "./AddAlarm.vue?vue&type=template&id=15f996f3&scoped=true"
import script from "./AddAlarm.vue?vue&type=script&lang=js"
export * from "./AddAlarm.vue?vue&type=script&lang=js"

import "./AddAlarm.vue?vue&type=style&index=0&id=15f996f3&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f996f3"]])

export default __exports__